import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";

export const RELOCATION_ORDER_PICKUP_LOCATIONS_RESOURCE = "relocation-order" as const;
export const RELOCATION_ORDER_PICKUP_LOCATIONS_OPERATION = "pickup-locations" as const;
export const RELOCATION_ORDER_PICKUP_LOCATIONS_API_PATH =
  `/v1/${RELOCATION_ORDER_PICKUP_LOCATIONS_RESOURCE}/${RELOCATION_ORDER_PICKUP_LOCATIONS_OPERATION}` as const;

export type PickupLocationsBody =
  paths[typeof RELOCATION_ORDER_PICKUP_LOCATIONS_API_PATH]["post"]["requestBody"]["content"]["application/json"];
export type PickupLocationsResponse =
  paths[typeof RELOCATION_ORDER_PICKUP_LOCATIONS_API_PATH]["post"]["responses"][200]["content"]["application/json"];

export function useRelocationOrderPickupLocationsQuery(
  body?: PickupLocationsBody,
  queryOptions?: Omit<
    UseQueryOptions<PickupLocationsResponse, Error, PickupLocationsResponse, readonly unknown[]>,
    "queryKey" | "queryFn"
  >,
) {
  const requestBody = body ?? {};

  return useQuery({
    queryKey: [
      RELOCATION_ORDER_PICKUP_LOCATIONS_RESOURCE,
      RELOCATION_ORDER_PICKUP_LOCATIONS_OPERATION,
      { body: requestBody },
    ],
    queryFn: async () => {
      const response = await alphartisApiAxios.post<PickupLocationsResponse>(
        RELOCATION_ORDER_PICKUP_LOCATIONS_API_PATH,
        requestBody,
      );

      return response.data;
    },
    ...queryOptions,
  });
}
